import BaseServiceApi from "BaseServiceApi";
import GetAiInsightsCategoriesRequest from "../Requests/GetAiInsightsCategoriesRequest";
import GetAiInsightsSelectedReportDataRequest from "../Requests/GetAiInsightsSelectedReportDataRequest";
import SetAiInsightsTextReactions from "../Requests/SetAiInsightsTextReactions";

class AiInsightsApi {
  getAiInsightsCategories() {
    const req = new GetAiInsightsCategoriesRequest();
    return BaseServiceApi.processAIServiceCall(req);
  }

  getAiInsightsSelectedReportData(symbol, companyName, stockId, insightCategory) {
    const req = new GetAiInsightsSelectedReportDataRequest(symbol, companyName, stockId, insightCategory);
    return BaseServiceApi.processAIServiceCall(req);
  }

  setAITextReactions(data) {
    const req = new SetAiInsightsTextReactions(data);
    return BaseServiceApi.processAIServiceCall(req);
  }
}

var aiInsightsApi = new AiInsightsApi();
export default aiInsightsApi;
